import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["answer", "doorPanel", "button", "indicator"]

  toggle() {
    const isOpen = this.answerTarget.classList.toggle("is-open")
    this.doorPanelTarget.classList.toggle("is-open", isOpen)
    this.buttonTarget.setAttribute("aria-expanded", isOpen)
    this.indicatorTarget.textContent = isOpen ? "−" : "+"

    if (isOpen) {
      this.answerTarget.style.maxHeight = `${this.answerTarget.scrollHeight}px`
    } else {
      this.answerTarget.style.maxHeight = null
    }
  }
}
